import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../src/components/DashboardLayout/DasboardLayout";
import { API_URL } from "../../../src/components/config";

const LowestTwentyDrivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [lowestDrivers, setLowestDrivers] = useState([]);

  const fetchDrivers = () => {
   fetch(`${API_URL}/driver`)
      .then((res) => res.json())
      .then((data) => {
        const sorted = data
          .filter(d => d.trips_completed !== null && !isNaN(d.trips_completed))
          .sort((a, b) => a.trips_completed - b.trips_completed)
          .slice(0, 20);
        setDrivers(data);
        setLowestDrivers(sorted);
      })
      .catch((error) => console.error("Error fetching drivers:", error));
  };

  useEffect(() => {
    fetchDrivers();
    const interval = setInterval(fetchDrivers, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <DashboardLayout>
      <div className="p-6 bg-white dark:bg-gray-800 min-h-screen">
        <h1 className="text-3xl font-bold mb-6 text-[#8a1c1c] dark:text-white">
          Lowest 20 Performing Drivers
        </h1>

        <div className="overflow-x-auto shadow-md rounded-lg">
          <table className="w-full text-sm text-left text-gray-700 dark:text-gray-300">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-300">
              <tr>
                <th className="px-6 py-3">#</th>
                <th className="px-6 py-3">Driver ID</th>
                <th className="px-6 py-3">Name</th>
                <th className="px-6 py-3">Phone</th>
                <th className="px-6 py-3">Email</th>
                <th className="px-6 py-3">Vehicle Info</th>
                <th className="px-6 py-3">Passengers</th>
                <th className="px-6 py-3">Delivery Capacity</th>
                <th className="px-6 py-3">Trips Completed</th>
                <th className="px-6 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {lowestDrivers.map((driver, index) => (
                <tr
                  key={driver.driver_id}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td className="px-6 py-4 font-semibold">{index + 1}</td>
                  <td className="px-6 py-4">{driver.driver_id}</td>
                  <td className="px-6 py-4">{driver.name} {driver.surname}</td>
                  <td className="px-6 py-4">+{driver.phone}</td>
                  <td className="px-6 py-4">{driver.email || "N/A"}</td>
                  <td className="px-6 py-4">
                    {driver.make} {driver.model} ({driver.colour})<br />
                    Plate: <span className="font-medium">{driver.plate}</span><br />
                    Year: {driver.vehicle_year} | Category: {driver.vehicle_category}
                  </td>
                  <td className="px-6 py-4">{driver.number_of_passangers || 0}</td>
                  <td className="px-6 py-4">
                    {driver.delivery_volume} kg / {driver.delivery_weight} kg
                  </td>
                  <td className="px-6 py-4 text-red-700 font-bold">
                    {driver.trips_completed}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-2 py-1 text-xs rounded-full font-medium ${
                        driver.driving_status === "ready"
                          ? "bg-green-100 text-green-800"
                          : "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {driver.driving_status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {lowestDrivers.length === 0 && (
          <div className="text-center py-4 text-gray-500 dark:text-gray-400">
            No driver data available.
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default LowestTwentyDrivers;
